import { type ComponentPropsWithoutRef, forwardRef, type SVGProps } from 'react';
import { IconContainer } from '@/icons';
import ZepIcon, { type IconSize } from '@/icons/ZepIcon';
import { cn } from '@/utils';
type CheckBoxProps = ComponentPropsWithoutRef<'div'> & {
  checked: boolean;
  className?: string;
  size?: IconSize;
  disabled?: boolean;
};

/**
 * @experimental 아직 완성되기 전입니다.
 */
export const Checkbox = forwardRef<HTMLDivElement, CheckBoxProps>(({
  className,
  size = 'sm',
  checked,
  disabled,
  ...props
}, ref) => {
  return <div role="checkbox" aria-checked={checked} aria-disabled={disabled} ref={ref} tabIndex={disabled ? -1 : 0} className={cn('rounded-2xs p-4xs', className, disabled && 'cursor-not-allowed')} {...props}>
        <IconContainer>
          {checked ? <Checked size={size} /> : <NonChecked size={size} disabled={disabled} />}
        </IconContainer>
      </div>;
});
Checkbox.displayName = 'Checkbox';
const NonChecked = ZepIcon((props: SVGProps<SVGSVGElement> & {
  disabled?: boolean;
}) => {
  const {
    disabled,
    ...svgProps
  } = props;
  return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...svgProps} fill="none">
        <g clipPath="url(#clip0_8340_1104)">
          <rect width="20" height="20" rx="2" fill={disabled ? '#F0F2F6' : 'white'} />
          <path fillRule="evenodd" clipRule="evenodd" d="M18 2H2V18H18V2ZM2 0C0.895431 0 0 0.895431 0 2V18C0 19.1046 0.895431 20 2 20H18C19.1046 20 20 19.1046 20 18V2C20 0.895431 19.1046 0 18 0H2Z" fill="#CACBD8" />
          <path d="M14.6644 6.2526C15.0772 6.61952 15.1143 7.25159 14.7474 7.66437L9.41409 13.6644C9.22432 13.8779 8.95232 14 8.66668 14C8.38104 14 8.10904 13.8779 7.91927 13.6644L5.2526 10.6644C4.88568 10.2516 4.92286 9.61952 5.33565 9.2526C5.74843 8.88568 6.3805 8.92286 6.74742 9.33565L8.66668 11.4948L13.2526 6.33565C13.6195 5.92286 14.2516 5.88568 14.6644 6.2526Z" fill="#CACBD8" />
        </g>
        <defs>
          <clipPath id="clip0_8340_1104">
            <rect width="20" height="20" rx="2" fill="white" />
          </clipPath>
        </defs>
      </svg>;
}) as React.FC<SVGProps<SVGSVGElement> & {
  size?: IconSize;
  disabled?: boolean;
}>;
const Checked = ZepIcon(props => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <g clipPath="url(#clip0_8340_2350)">
      <path fillRule="evenodd" clipRule="evenodd" d="M2 0C0.895431 0 0 0.895431 0 2V18C0 19.1046 0.895431 20 2 20H18C19.1046 20 20 19.1046 20 18V2C20 0.895431 19.1046 0 18 0H2Z" fill="#6758FF" />
      <path d="M14.6644 6.2526C15.0772 6.61952 15.1143 7.25159 14.7474 7.66437L9.41409 13.6644C9.22432 13.8779 8.95232 14 8.66668 14C8.38104 14 8.10904 13.8779 7.91927 13.6644L5.2526 10.6644C4.88568 10.2516 4.92286 9.61952 5.33565 9.2526C5.74843 8.88568 6.3805 8.92286 6.74742 9.33565L8.66668 11.4948L13.2526 6.33565C13.6195 5.92286 14.2516 5.88568 14.6644 6.2526Z" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_8340_2350">
        <rect width="20" height="20" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>);